<div style="position: relative;">
    <a [href]="data.link"><img [src]="data.imagePath"></a>
    <button mat-button (click)="onNoClick()" class="theme-button"><mat-icon>close</mat-icon>Close</button>
</div>